import React, { useState, useEffect } from 'react';
import { CiLocationOn } from 'react-icons/ci';

function Home() {

  const places = [
    {
      id: 1,
      image: '/Assets/peru.webp',
      title: "Experience Paradise on Peru's Coast",
      content: "Dive into the warm embrace of Mancora's golden beaches. This seaside oasis is famous for its incredible waves, lively atmosphere, and breathtaking sunsets. Discover a blend of relaxation and adventure in this hidden gem of Peru.",
      location: "Mancora", country: "Peru"
    },
    {
      id: 2,
      image: '/Assets/jordan.webp',
      title: 'Step into the Lost City of Petra',
      content: "Unearth the secrets of this ancient rose-red city hidden within the Jordanian desert. Carved into the rugged cliffs, Petra's intricate architecture and stunning rock-cut facades will transport you to a world steeped in history and mystery.",
      location: "Petra", country: "Jordan"
    },
    {
      id: 3,
      image: '/Assets/cabo.webp',
      title: "Discover Paradise in Cabo San Lucas, Mexico",
      content: "Nestled at the southern tip of the Baja California Peninsula, Cabo San Lucas, Mexico, is a sun-soaked paradise that beckons travelers from around the world. This coastal gem is renowned for its striking beauty, vibrant nightlife, and a rich blend of Mexican culture and modern luxury.",
      location: "Cabo San Lucas", country: "Mexico"
    },
    {
      id: 4,
      image: '/Assets/bali.webp',
      title: "Discover Bali's Island Paradise",
      content: "Bali is a tapestry of vibrant culture, lush landscapes, and serene beaches. Immerse yourself in Balinese traditions, unwind on pristine shores, and chase unforgettable sunsets. The 'Island of the Gods' offers an unforgettable escape.",
      location: "Bali", country: "Indonesia"
    },
    {
      id: 5,
      image: '/Assets/greece.webp',
      title: "Surrender to Santorini's Allure",
      content: 'Surreal sunsets over the caldera, picturesque white-washed buildings, and crystal-clear waters await in Santorini. This Greek island gem is a haven for romance and relaxation, where you can soak in the Mediterranean bliss.',
      location: "Santorini", country: "Greece"
    },
    {
      id: 6,
      image: '/Assets/turkey.webp',
      title: 'Soar Above the Fairy Chimneys',
      content: "Cappadocia's otherworldly landscapes, adorned with whimsical 'fairy chimneys,' are a dream come true for adventurers. Take a hot air balloon ride at sunrise and witness the magical spectacle of this Turkish wonderland.",
      location: "Cappadocia", country: "Turkey"
    },
  ]

  const [currentIndex, setCurrentIndex] = useState(0);
  const currentSlide = places[currentIndex];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(currentIndex => (currentIndex + 1) % places.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [places.length]);

  return (
    <div className='slideshow'>
      {places.map((slide) => (
        <div id='slide'
          key={slide.id}
          className={(slide.id === currentSlide.id) ? 'active' : ''}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          {slide.id === currentSlide.id && (
            <div className="text-container">
              <h1 className="title">{slide.title}</h1>
              <p className="subtitle">{slide.content}</p>
              <div className="location">
                <CiLocationOn className='icon' />
                <p>{slide.location}, {slide.country}</p>
              </div>
            </div>
          )}

        </div>
      ))}
    </div>
  )
}

export default Home;